module.exports = __webpack_public_path__ + "static/media/batman-hited.99148a32.png";